import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { database, ref, set } from '../firebase/config';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';

const ApplicationForm = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const location = useLocation();
  const { mobile, password } = location.state || {};
  const navigate = useNavigate();
  const topRef = useRef(null);
  const stepContainerRef = useRef(null);

  const [formData, setFormData] = useState({
    mobile: mobile || '',
    password: password || '',
    name: '',
    dob: '',
    address: '',
    pincode: '',
    loanAmount: '',
    tenure: '',
    interestRate: 6,
    loanPurpose: '',
    employmentType: '',
    panNumber: '',
    panPhoto: '',
    aadharNumber: '',
    aadharFront: '',
    aadharBack: '',
    userPhoto: ''
  });

  // Scroll to top whenever step changes
  useEffect(() => {
    // Smooth scroll to top of the form container
    if (topRef.current) {
      topRef.current.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start' 
      });
    }
    // Also scroll window to top
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [currentStep]);

  // Redirect if no mobile/password
  if (!mobile || !password) {
    navigate('/apply');
    return null;
  }

  const nextStep = () => {
    setCurrentStep(currentStep + 1);
  };

  const prevStep = () => {
    setCurrentStep(currentStep - 1);
  };

  const submitApplication = async () => {
    const applicationId = 'LOAN' + Date.now();
    const applicationData = {
      ...formData,
      applicationId: applicationId,
      status: 'pending',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };

    // Keep password for verification
    // applicationData.password is kept for login verification

    try {
      // Store by mobile number for easy lookup
      const applicationRef = ref(database, `applications/${mobile}`);
      await set(applicationRef, applicationData);
      
      // Also store by application ID for reference
      const idRef = ref(database, `applications_by_id/${applicationId}`);
      await set(idRef, { mobile, applicationId });
      
      navigate(`/success/${applicationId}`);
    } catch (error) {
      console.error('Error submitting application:', error);
      alert('Failed to submit application. Please try again.');
    }
  };

  return (
    <div className="application-form-container" ref={topRef}>
      <div className="horizontal-stepper">
        <div className={`stepper-step ${currentStep >= 1 ? 'active' : ''} ${currentStep > 1 ? 'completed' : ''}`}>
          <div className="stepper-circle">1</div>
          <div className="stepper-label">Personal Details</div>
        </div>
        <div className={`stepper-line ${currentStep >= 2 ? 'active' : ''}`}></div>
        <div className={`stepper-step ${currentStep >= 2 ? 'active' : ''} ${currentStep > 2 ? 'completed' : ''}`}>
          <div className="stepper-circle">2</div>
          <div className="stepper-label">Loan Details</div>
        </div>
        <div className={`stepper-line ${currentStep >= 3 ? 'active' : ''}`}></div>
        <div className={`stepper-step ${currentStep >= 3 ? 'active' : ''}`}>
          <div className="stepper-circle">3</div>
          <div className="stepper-label">Documents</div>
        </div>
      </div>
      
      {currentStep === 1 && (
        <Step1 formData={formData} setFormData={setFormData} nextStep={nextStep} />
      )}
      {currentStep === 2 && (
        <Step2 formData={formData} setFormData={setFormData} nextStep={nextStep} prevStep={prevStep} />
      )}
      {currentStep === 3 && (
        <Step3 formData={formData} setFormData={setFormData} prevStep={prevStep} submitApplication={submitApplication} />
      )}
    </div>
  );
};

export default ApplicationForm;